import React from 'react';
import anime from 'animejs';
import { Global, css, jsx } from '@emotion/react';

import YesplanLogo from './YesplanLogo';
import WindowBorder from '../styled components/WindowBorder';

const animation = () => {
  const logoAnimation = anime.timeline({
    autoplay: true,
    delay: 200
  });
  const loopLoader = function (anim) {
    const logoAnimationLoop = anime.timeline({
      autoplay: true,
      loop: true,
      delay: 500
    });
    logoAnimationLoop
      .add({
        targets: '#backside',
        opacity: [0, 1],
        scale: [0, 1],
        rotate: [-360, 0],
        duration: 1000,
        easing: 'easeOutSine'
      })
      .add(
        {
          targets: ['#frontside', '#letter'],
          scale: [0, 1],
          opacity: [0, 1],
          rotate: [-30, 0],
          duration: 700,
          easing: 'easeInOutCubic'
        },
        '-=1100'
      )
      .add({
        targets: ['#backside', '#frontside', '#letter'],
        rotate: [0, 360],
        scale: [1, 0.6],
        opacity: [1, 0],
        duration: 1000,
        easing: 'easeInOutCubic'
      });
  };

  logoAnimation
    .add({
      targets: '#cube',
      rotate: [-360, 0],
      opacity: [0, 1],
      duration: 1000,
      easing: 'easeOutSine',
      delay: 200
    })
    .add(
      {
        targets: '#letters .letter',
        translateX: [80, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: 'easeOutCubic',
        duration: 1000,
        delay(el, i) {
          return 50 + 30 * i;
        }
      },
      '-=700'
    )
    .add({
      targets: ['#backside', '#frontside', '#letter'],
      opacity: [1, 0],
      scale: [1, 0.6],
      rotate: [0, 360],
      duration: 1000,
      easing: 'easeInOutCubic',
      complete: loopLoader
    });
  return logoAnimation;
};

export default class Authenticating extends React.Component {
  componentDidMount() {
    this.animation = animation();
  }

  componentWillUnmount() {
    this.animation.pause();
  }

  render() {
    return (
      <div tw="max-w-xl">
        {/* Specific body styling for this page */}
        <Global
          styles={css`
            body {
              background: '#f9f9f9';
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
            }
          `}
        />
        <YesplanLogo />
        <WindowBorder />
      </div>
    );
  }
}
